
export const fontWeight = {
  regular: 400,
  medium: 500,
  bold: 700,
  black: 900,
} as const;
